import { debounce } from 'lodash';
import { Search } from 'lucide-react';
import { useEffect, useMemo, useState } from 'react';

import { Input } from '@/design-system/components/ui';

interface SearchBarProps {
  value: string;
  onChange: (value: string) => void;
}

export const TriggerTypeSearchBar = ({ value, onChange }: SearchBarProps) => {
  const [inputValue, setInputValue] = useState(value);

  const debouncedOnChange = useMemo(
    () =>
      debounce((query: string) => {
        onChange(query);
      }, 200),
    [onChange],
  );

  useEffect(() => {
    debouncedOnChange(inputValue);
  }, [inputValue, debouncedOnChange]);

  return (
    <Input
      placeholder="Search triggers..."
      value={inputValue}
      onChange={(e) => setInputValue(e.target.value)}
      leftSlot={<Search size={20} />}
    />
  );
};
